<template lang="html">
<div class="h-full flex flex-col">
  <div id="nav-control" class="w-full flex justify-between items-end mb-1">
    <div id="title-label" class="text-lg font-medium">
      <span v-show="!isSharedVideos">Takes</span>
      <span v-show="isSharedVideos">Shared takes</span>
    </div>
    <!-- Video takes folder selector -->
    <div class="flex space-x-2 items-center" :class="isDirector ? 'w-3/5' : 'w-2/5'">

      <div class="text-red-600 dark:text-red-400" v-show="isDirector" v-if="isDirector && videoTakesFolders && videoTakesFolders.length &&
       hostFolderSelected != currentVideoTakeFolderId && hostSelectedFolderName != 'None'">
        Host is in folder: <button @click="currentVideoTakeFolderId = hostFolderSelected; changeCurrentVideoTakes()" class="underline">{{ hostSelectedFolderName }}</button> 
      </div>
      <div id="video-takes-selector" class="flex-grow" v-show="!isSharedVideos && videoTakesFolders.length > 0">
        <select id="video-takes-folder" v-model="currentVideoTakeFolderId" @change="changeCurrentVideoTakes($event)" name="location" class="form-input">
          <option value="none">Select a folder...</option>
          <option v-for="(vtf, i) in videoTakesFolders" :key="'vtf-'.i" :value="vtf.id">{{vtf.name}}</option>
        </select>
      </div>
      <div class="" v-show="!isSharedVideos && !isDirector">
        <button @click="this.showFoldersModal" class="btn btn-secondary" data-e2e="new_folder_test" >
          New folder
        </button>
      </div> <!-- Video takes folder selector END -->
    </div>
    <div class="flex items-center"  v-show="!isSharedVideos && !isDirector">
      <!-- View Selector -->
      <div class="hidden">
        <div id="view-label" class="px-5">
          View
        </div>
        <div class="flex items-center">
          <button type="button" class="w-full text-base font-medium rounded-l-md hover:bg-gray-100" @click="layout = 'grid'">
            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
            </svg>
          </button>
          <button type="button" class="w-full text-base font-medium rounded-r-md hover:bg-gray-100" @click="layout = 'list'">
            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
      <!-- View Selector END -->
      <button class="btn btn-secondary px-1 py-1 hidden"  @click="showFavorites = !showFavorites">
        <span v-show="!showFavorites" class="flex items-center">
          <svg class="h-6 w-6 fill-current mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18.8 8.022h-6.413L10 1.3 7.611 8.022H1.199l5.232 3.947-1.871 6.929L10 14.744l5.438 4.154-1.869-6.929L18.8 8.022zM10 12.783l-3.014 2.5 1.243-3.562-2.851-2.3 3.522.101 1.1-4.04 1.099 4.04 3.521-.101-2.851 2.3 1.243 3.562-3.012-2.5z"/></svg>
          Show only favorites
        </span>
        <svg class="h-6 w-6 fill-current" v-show="showFavorites" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 1.3l2.388 6.722H18.8l-5.232 3.948 1.871 6.928L10 14.744l-5.438 4.154 1.87-6.928-5.233-3.948h6.412L10 1.3z"/></svg>
      </button>

      <!-- Filters -->
      <div id="filter-label" class="pl-5 pr-2" v-show="!isSharedVideos && !isDirector">
        Filters
      </div>
      <div id="filters" class="grid grid-cols-4 gap-2 w-64" v-show="!isSharedVideos && !isDirector">
        <div id="f-favorites" class="relative">
          <!-- <label for="favorites" class="absolute -mt-5 text-sm text-gray-500">Favorites</label> -->
          <select data-tippy-content="Favorites" id="favorites" v-model="showFavorites" @change="changeRoll($event)" name="location" class="form-input px-2 py-1 h-8">
            <option selected :value="false">All</option>
            <option value="true"> Favorites only </option>
          </select>
        </div>
        <div id="f-roll" class="relative">
          <!-- <label for="roll" class="absolute -mt-5 text-sm text-gray-500">Roll</label> -->
          <select  data-tippy-content="Roll"  id="roll" v-model="currentRoll" @change="changeRoll($event)" name="location" class="form-input px-2 py-1 h-8">
            <option selected :value="-1">-</option>
            <option v-for="(r, i) in this.rolls" :key="'r-'.i" :value="r.id">{{ r.number }}</option>
          </select>
        </div>
        <div id="f-scene" class="relative">
          <!-- <label for="scene" class="absolute -mt-5 text-sm text-gray-500">Scene</label> -->
          <select  data-tippy-content="Scene" id="scene" v-model="currentScene" @change="changeScene($event)" name="location" class="form-input px-2 py-1 h-8">
            <option selected :value="-1">-</option>
            <option v-for="(sc, i) in this.scenes" :key="'sc-'.i" :value="sc.id">{{sc.number}}</option>
          </select>
        </div>
        <div id="f-shot" class="relative">
          <!-- <label for="shot" class="absolute -mt-5 text-sm text-gray-500">Shot</label> -->
          <select  data-tippy-content="Shot" id="shot" v-model="currentShot" @change="changeShot($event)" name="location" class="form-input px-2 py-1 h-8">
            <option selected :value="-1">-</option>
            <option v-for="(s, i) in this.shots" :key="'s-'.i" :value="s.id">{{s.number}}</option>
          </select>
        </div>
      </div>
      <!-- Filters END -->
    </div>
  </div>
  <div class="overflow-scroll md:overflow-auto px-2 py-2 bg-gray-50 dark:bg-gray-800 shadow-inner rounded-md mt-2 grow" v-if="!isController">
    <div v-for="key in Object.keys(groupedVideoTakes)" v-if="!isController">
      <div class="mt-1 sm:mt-5">
        <h3> Roll: {{ getRollFromId(key) }} </h3>
        <transition-group name="slide-in"  @before-leave="beforeLeave" tag="ul" :class="{hidden: layout !== 'grid', 'xl:grid-cols-8': !isDirector}" class="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-5 px-0 mt-2">
          <video-take v-for="(vt, i) in groupedVideoTakes[key]" v-bind:key="'vt-' + vt.id + '_' + i"
                      :vt="vt" :index="i" :isSharedVideos="isSharedVideos" :canFavorite="!isDirector" @toggleFavorite="toggleFavorite(vt)" @loadClipPlayback="loadClipPlayback(vt)"></video-take>
        </transition-group>
      </div>
      <hr class="dark:border-gray-600" />
    </div>
  </div>
  <!-- takes container fco-->
  <div id="takes-container" class="flex-grow bg-gray-50 dark:bg-gray-800 shadow-inner rounded-md px-2 overflow-y-scroll" v-show="currentVideoTakes" v-if="isController">
    <transition-group name="slide-in"  @before-leave="beforeLeave" tag="ul" :class="{hidden: layout !== 'grid'}" class="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-5 px-0 mt-2">
      <video-take v-for="(vt, i) in filteredVideoTakes" v-bind:key="'vt-' + vt.id + '_' + i"
                  :vt="vt" :index="i" :isSharedVideos="isSharedVideos" :canFavorite="!isDirector" @toggleFavorite="toggleFavorite(vt)" @loadClipPlayback="loadClipPlayback(vt)"></video-take>
    </transition-group>

    <ul :class="{hidden: layout !== 'list'}" class="divide-y divide-gray-200 dark:divide-gray-500">
      <li v-for="(vt, i) in this.currentVideoTakes" :key="'vt-'.i">
        <a href="#" class="block hover:bg-gray-50">
          <div class="flex items-center px-4 py-4 sm:px-6">
            <div class="min-w-0 flex-1 flex items-center">
              <div class="flex-shrink-0">
                <img class="h-24 w-32" src="https://axiomcom.com/wp-content/uploads/2017/02/sky-over-ocean-400x300.jpg" alt="">
              </div>
              <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                <div>
                  <p class="text-sm font-medium text-blue-600 truncate">{{ vt.name }}</p>
                  <p class="mt-2 flex items-center ">
                    <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      New
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div>
              <!-- Heroicon name: solid/chevron-right -->
              <svg class="h-12 w-12 text-blue-600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clip-rule="evenodd" />
              </svg>
            </div>
          </div>
        </a>
      </li>
    </ul>
  </div>
  <!-- Create folder modal -->
  <modal :showModal="showCreateFolderModal" @close="showCreateFolderModal = false">
    <div class="mt-3 text-center sm:mt-5">
      <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
        Create a new folder
      </h3>
      <div class="mt-2">
        <p class="text-sm text-gray-500">
          Create a folder to organize your takes. You can create as many folders as you want.
        </p>
      </div>
    </div>
    <div class="mx-5 my-3">
      <label class="font-bold">Name</label>
      <input type="text" data-e2e="newFolderNameInput" class="form-input" placeholder="Name of the folder" v-model="newFolderName">
    </div>
    <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
      <button type="button" class="btn btn-primary sm:col-start-2 sm:text-sm" data-e2e="create_folder_test" @click="createVideoTakeFolder">
        Create folder
      </button>
      <button @click="showCreateFolderModal = false" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm">
        Cancel
      </button>
    </div>
  </modal>
  <!-- Playback modal -->
  <modal :showModal="showPlaybackModal" @close="goBackLive()" classSize="lg:max-w-4xl">
    <div class="relative overflow-hidden" data-id="videoTakeViewport" id="readyToPlay" v-if="selectedTake">
      <div id="mask-before" class="absolute opacity-50 bg-black"></div>
      <div id="mask-after" class="absolute opacity-50 bg-black"></div>
      <video :src="selectedTake.file_url" class="w-full playback mx-auto left-0 right-0 transform transition-all duration-300 bg-black" 
      :class="getRotationAngle(selectedTake.rotation)" :id="videoId" preload="auto" playsinline></video>
      <div class="video-overlay absolute inset-0">
        <!-- Video Controls -->
        <div class="video-controls" :id="videoId + '_controls'"></div>
        <!-- Selected key -->
        <div class="text-white text-2xl px-4 py-2 absolute top-0 left-0 z-10 opacity-75 capitalize" id="tag"></div>
        <!-- selected name -->
        <div class="text-white text-2xl px-4 py-2 absolute top-0 right-0 z-10 opacity-75" id="name">{{ selectedTake.name }}</div>
      </div>
      <div class="processing text-3xl text-white absolute top-0 left-0 h-full w-full text-center bg-black flex items-center justify-center" v-show="processingClip">
        <div>
          <div class="loader mx-auto mb-10"></div>
          Loading video...
        </div>
      </div>
    </div>
    <div class="mt-5">
      <div id="thumbnails" class="hidden">This shouldnt be shown</div>
      <!-- Host only buttons -->
      <div v-if="isDirector == false">
        <!-- Host View only buttons -->
        <div v-if="!isSharedVideos">
          <div class="flex justify-between">
            <div id="continuity" class="">
              <label class="font-medium text-lg"> Continuity </label>
              <button class="btn" @click="setAsPrevious" :disabled="processingClip" :class="processingClip ? 'btn-disabled' : 'btn-secondary'"> Set as Previous </button>
              <button class="btn" @click="setAsCurrent" :disabled="processingClip" :class="processingClip ? 'btn-disabled' : 'btn-secondary'"> Set as Current </button>
              <button class="btn" @click="setAsNext" :disabled="processingClip" :class="processingClip ? 'btn-disabled' : 'btn-secondary'"> Set as Next </button>
              <div class="text-gray-500 mt-2">
                If you choose any continuity option for this take,
                the cue will be set on the frame you are currently watching.
              </div>
            </div>
            <div>
              <button v-if="videoLeaderEnabled" id="requestVideoLeaderButton" class="btn btn-secondary hidden" @click="requestVideoLeaderWrapper()">
                Become video leader
              </button>
            </div>
            <div>
              <label class="font-medium text-lg"> Aspect ratio </label>
              <select @change="changeMaskViewport()" v-model="selectedTake.aspect_ratio" class="form-input pr-10" v-if="selectedTake">
                    <option value="16:9">16:9  Default </option>
                    <option value="2:3">2:3  FB post</option>
                    <option value="4:5">4:5  IG+FB post</option>
                    <option value="1:1">1:1  Square</option>
                    <option value="4:3">4:3  TV </option>
                    <option value="1.91:1">1.91:1  IG Videos</option>
              </select>
            </div>
          </div>
      <!-- Participants status list-->
      <div class="font-bold text-lg mt-5" v-if="participants.length"> Participants </div>
      <div class="grid grid-cols-3 gap-2">
          <div v-for="peer in participants">
            <div :id="`ready_${peer.role}_${peer.public_key}`" class="grid grid-cols-2 gap-1">
              <div>
                <div class="text-sm leading-snug"> {{peer.name}}</div>
                <div class="text-gray-400 leading-none text-xs">{{peer.role}}</div>
              </div>
              <div class="status text-sm mt-1">LOADING ⏳</div>
            </div>
          </div>
        </div>
      </div>
      <!-- Download icons-->
      <a :href="selectedTake.file_url" target="_blank" class="btn btn-primary flex items-center float-left mt-4" v-if="selectedTake && isSharedVideos">
        <!-- Download icon -->
        <svg xmlns="http://www.w3.org/2000/svg" class="fill-current h-4 w-4 inline-block"  viewBox="0 0 20 20"><path d="M15 7h-3V1H8v6H5l5 5 5-5zm4.338 6.532c-.21-.224-1.611-1.723-2.011-2.114A1.503 1.503 0 0 0 16.285 11h-1.757l3.064 2.994h-3.544a.274.274 0 0 0-.24.133L12.992 16H7.008l-.816-1.873a.276.276 0 0 0-.24-.133H2.408L5.471 11H3.715c-.397 0-.776.159-1.042.418-.4.392-1.801 1.891-2.011 2.114-.489.521-.758.936-.63 1.449l.561 3.074c.128.514.691.936 1.252.936h16.312c.561 0 1.124-.422 1.252-.936l.561-3.074c.126-.513-.142-.928-.632-1.449z"/></svg>
        <div class="pl-1"> Download </div>
      </a>
      </div>
      <button class="underline text-lg flex justify-center items-center float-right w-full sm:w-auto" @click="goBackLive()">
        <!-- Close icon -->
        <svg xmlns="http://www.w3.org/2000/svg" class="fill-current h-4 w-4 inline-block" viewBox="0 0 20 20"><path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"/></svg>
        <div class="pl-1"> Close </div>
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import CustomPlayer from 'utils/custom-player'
import { localNotify } from 'utils/notifications'
import {setGetLastVideoTake, setVideoTakeFolderId} from 'mirror/videorecordings';
import commandsManager from 'general/CommandsManager'
import hooksManager from 'general/HooksManager'

import axios from 'axios'
// clip playback
import { getRotationAngle } from 'utils/rotate-viewport'
import messageBroker from 'general/messageBroker';
import { generateThumbnails } from 'utils/thumbnails';

import VideoTake from './video-take.vue'

import tippy from 'tippy.js';

import { setVideoLeadershipListenersHTML5, setupVideoLeadershipMessageTypes, requestVideoLeader } from 'mirror/video-leadership';

import { changeAudioDestination } from 'webrtc/mediaDevices';

export default {
  name: "video-takes-list",
  components: {
    VideoTake
  },
  props: {
    roomKey: {
      type: String,
      required: false,
      default: '',
    },
    sharedVideos: {
      type: Array,
      required: false,
      default: ()=>[],
    },
    sharedRolls: {
      type: Array,
      required: false,
      default: ()=>[],
    },
    isSharedVideos: {
      type: Boolean,
      required: false,
      default: false,
    },
    isController: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDirector: {
      type: Boolean,
      required: false,
      default: true,
    },
    demoModeOn: {
      type: Boolean,
      required: false,
      default: false,
    },
    videoLeaderEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      showCreateFolderModal: false,
      layout: 'grid',
      currentVideoTakeFolderId: 'none',
      hostFolderSelected: 0,
      roomActivated: false,
      currentVideoTakes: [],
      rollState: null,
      currentRoll: -1,
      currentScene: -1,
      currentShot: -1,
      rolls: [],
      scenes: [],
      shots: [],
      videoTakes: [],
      videoTakesFolders: [],
      showFavorites: false,
      rollSceneShotSetter: null,

      // for clip playback
      selectedTake: null,
      showPlaybackModal: false,
      participants: [],
      processingClip: false,

      newFolderName: '',
      isVideoLeader: true,

      uniqueId: "",
      customPlayer: null,

      //hooks:
      playWhenReady: false,
    }
  },
  methods: {
    // AJAX loads
    loadVideoTakeFolders(){
      axios.get('/video_take_folders')
           .then( (response) =>{
             this.videoTakesFolders = response.data
             this.videoTakesFolders.forEach(folder => {
               if (folder.name == "Demo folder" && !this.roomActivated){
                 this.currentVideoTakeFolderId = folder.id;
               }
             })
             this.changeCurrentVideoTakes();
           })
    },
    loadVideoTakesForFolder(folderId) {
      return new Promise((resolve) => {
        axios.get('/video_take_folders/' + folderId + '/video_takes')
          .then((response) => {
            resolve(response.data);
          })
      })
    },

    // Clip playback

    // Stop playback and go to livestream again
    // this is used when closing the playback modal
    goBackLive() {
      if(this.demoModeOn == false && this.isDirector == false){
        commandsManager.sendAllCommand('stop_video_clip', {});
      }
      this.showPlaybackModal = false;

      var playButton = document.querySelector("#"+this.videoId+"_controls .play-button");
      playButton.innerHTML = "Play";
      $('#' + this.videoId)[0].srcObject = null;
      if (vm.$refs.orchestrator){
        commandsManager.sendAllCommand('rotate_viewport', {angle: vm.$refs.orchestrator.$refs.viewport.angle})
        commandsManager.sendAllCommand('mask_viewport', {aspectRatio: vm.$refs.orchestrator.$refs.viewport.aspectRatio})
      }
      this.$emit('goBackLive')
    },

    async loadClipPlayback(take){
      this.showPlaybackModal = true;
      this.processingClip = true;
      if(this.demoModeOn == false && this.isDirector == false){
        commandsManager.sendAllCommand('load_video_clip', { url: take.file_url });
        this.setupParticipants();
      };

      // Defer a bit emiting the clip playback event to ensure that the camera turns off after the clip
      // is loaded already, the clip loading routine should disable the event handling the host turning
      // of the camera temporarily
      await new Promise((r) => setTimeout(r, 200));
      this.$emit('loadClipPlayback')

      this.setupReadyToPlay(take);
      // sleep for a bit to set the loading video request before trying
      // to find the clip duration
      await new Promise((r) => setTimeout(r, 200));

      generateThumbnails(this.videoId, 'thumbnails').then( () =>{
        this.processingClip = false;
        this.setupClipListeners();
        document.querySelector("#"+this.videoId).muted = false;
      })
    },
    setupMasks(){
      const maskBefore = $("[data-id='videoTakeViewport'] #mask-before");
      const maskAfter = $("[data-id='videoTakeViewport'] #mask-after");
      // remove old masks (if they exist)
      $("[data-id='videoTakeViewport']  #mask-before").remove();
      $("[data-id='videoTakeViewport']  #mask-after").remove();
      // append masks
      maskBefore.appendTo("[data-id='videoTakeViewport']");
      maskAfter.appendTo("[data-id='videoTakeViewport']");
    },

    setupFullscreenListeners(playbackPlayer){
      const videoEl = $('#' + this.videoId);
      window.setTimeout(()=>{
        playbackPlayer.on('enterfullscreen', (event) => {
          window.setTimeout(()=>{
            this.resizeVideo();
            const videoElWrapper = videoEl.parents('.plyr--video');;
            if(this.angle == 90 || this.angle == 270){
              videoEl.css('top', videoElWrapper.height()/8)
            }
          } , 100)
        });

        playbackPlayer.on('exitfullscreen', (event) => {
          window.setTimeout(()=>{
            // this.resizeVideo();
            videoEl.css('top', '0rem');
          } , 100)
        });
      }, 4000);
    },

    setupClipListeners(){
      this.setupMasks();

      // Setup video listeners to be able to remote control this video
      const videoEl = document.querySelector("#"+this.videoId)
      setVideoLeadershipListenersHTML5(videoEl);

      // this.setupFullscreenListeners(playbackPlayer);

      if(this.playWhenReady) {
        window.playbackPlayer.play();
        this.playWhenReady = false;
      }
    },

    setupParticipants(){
      // TODO: fix setup participants
      this.participants = []
      for (let i = manager.peerList.length - 1; i >= 0; i--) {
        const peer = manager.peerList[i];
        if (peer.status == "connected"){
          this.participants.push(peer)
        };
      }
    },

    setupReadyToPlay(take) {
      this.selectedTake = take;
      const rotation = parseInt(this.selectedTake.rotation);
      const aspectRatio = this.selectedTake.aspect_ratio;
      commandsManager.sendAllCommand('rotate_viewport', {angle: rotation});
      // Only activate the mask if its not in vertical
      if(rotation == 0 || rotation == 180){
        commandsManager.sendAllCommand('mask_viewport', {aspectRatio: aspectRatio})
      }

      // Update routes after creating the video
      window.setTimeout( () => {
        if (this.customPlayer == null){
          let video = document.getElementById(this.videoId);
          this.customPlayer = new CustomPlayer(video, document.querySelector("#"+this.videoId+"_controls"))
        }
        this.customPlayer.setupCustomControls()
        changeAudioDestination()
      }, 200)
    },
    setContinuity(key){
      const { currentTime } = $('#' + this.videoId)[0];
      let board =  vm.$refs.orchestrator.$refs.continuity;
      board.continuityBoard[key].id = this.selectedTake.id;
      board.continuityBoard[key].starts_at = currentTime;
      board.continuityBoard[key].url = this.selectedTake.file_url;
      board.continuityBoard[key].name = this.selectedTake.name;
      board.persistContinuityClip(key);
    },
    setAsPrevious(){
      // remove old previous
      this.videoTakes.filter(vt => vt.is_previous).forEach(vt => vt.is_previous = false);
      this.selectedTake.is_previous = true;
      this.selectedTake.tag = "Previous"
      this.setContinuity("previous")
    },
    setAsCurrent(){
      // remove old current
      this.videoTakes.filter(vt => vt.is_current).forEach(vt => vt.is_current = false);
      this.selectedTake.is_current = true;
      this.selectedTake.tag = "Current"
      this.setContinuity("current")
    },
    setAsNext(){
      // remove old next
      this.videoTakes.filter(vt => vt.is_next).forEach(vt => vt.is_next = false);
      this.selectedTake.is_next = true;
      this.selectedTake.tag = "Next"
      this.setContinuity("next")
    },
    resetFilter: function(){
      this.currentRoll = -1;
      this.currentScene = -1;
      this.currentShot = -1;
    },
    resetFiltersIfDifferentThanTake(take){
      if (this.currentRoll != take.roll_id){
        this.resetFilter();
      }
      else {
        if (this.currentScene != take.scene_id){
          this.resetFilter();
        }
        else {
          if(this.currentShot != take.shot_id){
            this.resetFilter();
          };
        }
      }
    },
    getLatestRollSceneShot: function(){
      const lastTake = this.videoTakes.filter(vt => vt.video_take_folder_id == this.currentVideoTakeFolderId).reverse()[0];

      if (lastTake === undefined) return;
      this.resetFiltersIfDifferentThanTake(lastTake);

      const roll = this.rolls.filter(r => r.id == lastTake.roll_id)[0];
      if(roll === undefined) return;
      const scene = roll.scenes.filter(s => s.id == lastTake.scene_id)[0]
      if(scene === undefined) return;
      const shot = scene.shots.filter(s => s.id == lastTake.shot_id)[0];
      if(shot === undefined) return;

      this.rollSceneShotSetter(roll.number, scene.number, shot.number)
    },
    changeCurrentVideoTakes: function(){
      // if it is director skip this load
      if (this.isDirector) return;
      this.loadVideoTakesForFolder(this.currentVideoTakeFolderId).then( (videoTakes) =>{
        this.currentVideoTakes = videoTakes;
        this.videoTakes = videoTakes;
        // We passed the reset filters functions for the new selected folder
        this.updateRollsState(this.getLatestRollSceneShot)

        // TODO:  refactor this to be executed after update roll state is run
        // this should be executed
        window.setTimeout( () => {
          // Update UI for directors
          this.sendVideoTakes();
        }, 1000)
      })
    },
    filterVideoTakes: function(videoTakesFolderId){
      if (this.isSharedVideos) return this.videoTakes;
      return this.videoTakes.filter(function (val) {
        return val.video_take_folder_id === videoTakesFolderId;
      })
    },
    showFoldersModal: function (){
      this.showCreateFolderModal = true;
    },
    createVideoTakeFolder(ev) {
      // validations
      let name = this.newFolderName;
      if (name.length == 0) return;

      let formData = new FormData();
      formData.append('authenticity_token', authenticity_token);
      formData.append('name', name);

      axios.post('/video_take_folders/', formData)
           .then( (response)=>{
             localNotify("Folder created successfully", "success")
             this.newFolderName = "";
             this.videoTakesFolders.push(response.data.video_take_folder);
             this.showCreateFolderModal = false;
             this.currentVideoTakeFolderId = this.videoTakesFolders[this.videoTakesFolders.length-1].id
             this.changeCurrentVideoTakes()
             // emit to other components that tis folder was created
             this.$root.$emit('videoTakeFolderCreated', response.data.video_take_folder);
           })
           .catch( (err) =>{
             console.error("Error creating folder", err);
           });
    },

    updateRollsState: function (onResponseCallback) {
      if (this.isDirector) return; // this may be the issue that the "roll" state is not being update properly, check on it
      if(this.currentVideoTakeFolderId === 'none') return;
      const headers = {'Accept': 'application/json'};
      axios.get('/video_take_folders/'+ (this.currentVideoTakeFolderId) + '/rolls_info', {headers}).then(response => {
        this.rollState = response.data;
        //this.currentRoll = -1;
        //this.currentScene = -1;
        //this.currentShot = -1;
        this.rolls = this.rollState;
        if(onResponseCallback != null)
          onResponseCallback();
      }).catch( (err) => { console.error(err) })
    },
    changeRoll: function () {
      if(this.currentRoll !== -1){
        this.scenes = this.rollState.find(x => x.id === this.currentRoll).scenes;
        this.currentVideoTakes = this.filterVideoTakes(this.currentVideoTakeFolderId)
                                     .filter(x => this.currentRoll === x.roll_id);
      } else { //show everything in folder
        this.currentVideoTakes = this.filterVideoTakes(this.currentVideoTakeFolderId);
        this.scenes = [];
      }
      this.currentScene = -1;
      this.currentShot = -1;
      this.shots = []
    },
    changeScene: function () {
      if(this.currentScene !== -1){
        this.shots = this.rollState.find(x => x.id === this.currentRoll).scenes.find(y => y.id === this.currentScene).shots;
        this.currentVideoTakes = this.filterVideoTakes(this.currentVideoTakeFolderId)
                                     .filter(x => this.currentRoll === x.roll_id && this.currentScene === x.scene_id);
      } else {// show everything
        this.currentVideoTakes = this.filterVideoTakes(this.currentVideoTakeFolderId)
                                     .filter(x => this.currentRoll === x.roll_id);
        this.shots = []
      }
      this.currentShot = -1;
    },
    changeShot: function () {
      if(this.currentShot !== -1){
        this.currentVideoTakes = this.filterVideoTakes(this.currentVideoTakeFolderId)
                                     .filter(x => this.currentRoll === x.roll_id && this.currentScene === x.scene_id && this.currentShot === x.shot_id);
      }else{
        this.currentVideoTakes = this.filterVideoTakes(this.currentVideoTakeFolderId)
                                     .filter(x => this.currentRoll === x.roll_id && this.currentScene === x.scene_id);
      }
    },
    getLastVideoTake: function (roll, scene, shot, videoTakeFolderId) {
      // NOTE FOR DEV:
      // the == in all of these functions is by design, sometimes the roll,scene,shot are numbers
      // sometimes they are strings, as javascript makes '1' == 1 true we can use it to compare
      // this of course is not recommended but needs further refactoring to make it work.
      // ensuring that roll scene shot are always the same type of value.
      var _roll = this.rollState.find(x => x.number == roll && x.video_take_folder_id === videoTakeFolderId);
      if(_roll === undefined)
        return 0;
      var _scene = _roll.scenes.find(y => y.number == scene);
      if(_scene === undefined)
        return 0;
      var _shot = _scene.shots.find(z => z.number == shot);
      return _shot === undefined ? 0 : _shot.last_video_take;
    },
    setRollSceneShotFn(fn){
      this.rollSceneShotSetter = fn;
    },
    // Credits to docmars to fix jump top left flip
    // https://forum.vuejs.org/t/transition-group-leave-transition-w-position-absolute-jumping-to-top-left-flip/12258/4
    beforeLeave(el) {
      const {marginLeft, marginTop, width, height} = window.getComputedStyle(el)
      el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 10)}px`
      el.style.top = `${el.offsetTop - parseFloat(marginTop, 10)}px`
      el.style.width = width
      el.style.height = height
    },
    toggleFavorite(vt){
      let formData = new FormData();
      formData.append('authenticity_token', authenticity_token);

      axios.post('/video_takes/'+vt.id+"/favorite", formData)
           .then( (response)=>{
             vt.is_favorite = response.data.video_take.is_favorite;
      	     this.sendVideoTakes();
           })
    },
    drawMaskViewport(){
      let ratio = this.selectedTake.aspect_ratio.split(":").reduce((a, b) => a/b);
      // left right
      const maskBefore = $("[data-id='videoTakeViewport'] #mask-before")
      const maskAfter = $("[data-id='videoTakeViewport'] #mask-after")

      const verticalClassListLeft = "inset-y-0 left-0"
      const verticalClassListRight = "inset-y-0 right-0"
      if (ratio < 16 / 9) {
        maskBefore.addClass(verticalClassListLeft).removeClass("inset-x-0 top-0");
        maskAfter.addClass(verticalClassListRight).removeClass("inset-x-0 bottom-0");
        maskBefore.css("height", 'initial');
        maskAfter.css("height", 'initial');
        const height = maskBefore.height();
        maskBefore.css("width", (height * (16 / 9 - ratio / 1)) / 2);
        maskAfter.css("width", (height * (16 / 9 - ratio / 1)) / 2);
      } else {
        // top bottom
        maskBefore
          .removeClass(verticalClassListLeft)
          .addClass("inset-x-0 top-0");
        maskAfter
          .removeClass(verticalClassListRight)
          .addClass("inset-x-0 bottom-0");
        maskBefore.css("width", "initial");
        maskAfter.css("width", "initial");
        const width = maskBefore.width();
        maskBefore.css("height", (width / 2) * (9 / 16 - 1 / ratio));
        maskAfter.css("height", (width / 2) * (9 / 16 - 1 / ratio))
      }
    },
    changeMaskViewport(){
      const aspectRatio = this.selectedTake.aspect_ratio;
      this.$emit('mask-viewport', aspectRatio)
      commandsManager.sendAllCommand('mask_viewport', {aspectRatio: aspectRatio})
    },
    resizeVideo(){
      const videoEl = $('#' + this.videoId);
      const videoElWrapper = videoEl.parents('.plyr--video');
      if(this.selectedTake == null) return;
      const rotation = parseInt(this.selectedTake.rotation);
      if(rotation == 0 || rotation == 180){
        videoEl.width(videoElWrapper.width());
      }
      if(rotation == 90 || rotation == 270){
        videoEl.width(videoElWrapper.height());
      }
      this.drawMaskViewport();
    },
    getCurrentFolderName(){
      let folder = this.videoTakesFolders.find(x => x.id === this.currentVideoTakeFolderId)
      if (folder == null) return;
      return folder.name;
    },
    getRotationAngle(rotation){
      this.resizeVideo();
      return getRotationAngle(rotation);
    },
    getRollFromId(id){
      return this.rolls.find(r => r.id == id) ? this.rolls.find(r => r.id == id).number : -1;
    },
    setHostEvents(){
      // Listen to root events
      this.$root.$on('videoRecordUploaded', (json) => {
        // if we have selected the folder this will refresh the rollState
        //
        if (json.video_take == null){
          console.error("error uploading video", json)
          return;
        }
        if(this.currentVideoTakeFolderId === json.video_take.video_take_folder_id ){
          this.updateRollsState(() => {
            // add video take to list, and update video takes;
            this.videoTakes.push(json.video_take);

            this.currentVideoTakes = this.filterVideoTakes(this.currentVideoTakeFolderId)
            // Set Filters to the values of the latest take
            // this.currentRoll = json.video_take.roll_id;
            // this.currentScene = json.video_take.scene_id;
            // this.currentShot = json.video_take.shot_id;
            this.resetFiltersIfDifferentThanTake(json.video_take);

            this.rolls = this.rollState;
            let currRoll = this.rollState.find(x => x.id === this.currentRoll);
            if (this.currRoll){
              this.scenes = currRoll.scenes;
              this.shots = currRoll.scenes.find(y => y.id === this.currentScene).shots;
            }

            this.sendVideoTakes();
          });
        } else{
          // add video take to list, and update video takes;
          this.videoTakes.push(json.video_take);
          this.sendVideoTakes();
        }
      })
      this.$root.$on('videoTakeFolderCreated', (videoFolder) => {
        if(this.videoTakesFolders.find(x => x.id === videoFolder.id) === undefined){
          this.videoTakesFolders.push(videoFolder);
          this.sendVideoTakes();
        }
      })
      this.$root.$on('roomActivated', () => {
        this.roomActivated = true;
        // only reset folder id if the currentVideoTakeFolder is not demo folder
        if (this.getCurrentFolderName() == 'Demo folder'){
          this.currentVideoTakeFolderId = 'none';
        }
        this.changeCurrentVideoTakes();
      })

      // register the command just so we can send it at sendVideoTakes();
      commandsManager.registerNewCommand('set_video_takes');
    },
    // Send the video takes to Directors/Production
    sendVideoTakes(){
      if (this.isDirector) return;
      console.trace("this is sending video takes");
      console.log(this.videoTakes, this.rolls);

      const videoTakes = this.videoTakes.filter((r) => { return r.room_key == this.roomKey })
      const validFolders = videoTakes.map( (vt) => { return vt.video_take_folder_id }); // get an array of valid ids

      let setVideoTakesCommand = commandsManager.getCommandById('set_video_takes');
      if (setVideoTakesCommand) {
        setVideoTakesCommand.sendToRole('production', {
          video_take_folders: this.videoTakesFolders.filter((f) => { return validFolders.includes(f.id) }),
          video_takes: videoTakes,
          shared_rolls: this.rolls,
          currentVideoTakeFolderId: this.currentVideoTakeFolderId,
        })
      }
    },
    requestVideoLeaderWrapper(){
      if(this.videoLeaderEnabled){
        requestVideoLeader();
      }
    },
    setVideoLeaderCallback(isVideoLeader){
      if(this.videoLeaderEnabled){
        this.isVideoLeader = isVideoLeader;
      }
    },
    initialize(){
      this.uniqueId = Math.random().toString(36).substr(7);

      switch (this.isDirector){
      case true:
        const self = this;
        commandsManager.registerNewCommand('set_video_takes', (data) => {
          self.videoTakesFolders = data.args.video_take_folders;
          if (self.videoTakesFolders.length == 1){
            // if its only one folder show it
            self.currentVideoTakeFolderId = self.videoTakesFolders[0].id;
          }
          if (self.currentVideoTakeFolderId == 'none'){
            // if its none, show the host selected folder
            self.currentVideoTakeFolderId = data.args.currentVideoTakeFolderId;
          }
          self.videoTakes = data.args.video_takes;
          self.currentVideoTakes = data.args.video_takes;
          self.rolls = data.args.shared_rolls.flat();
          self.hostFolderSelected = -1; // hack to force a recompute
          self.hostFolderSelected = data.args.currentVideoTakeFolderId;
        });
        break;
      case false:
        // resize video when window resizes
        window.addEventListener("resize", this.resizeVideo);
        if(this.isSharedVideos){
          this.videoTakes = this.sharedVideos;
          this.rolls = this.sharedRolls.flat();
          this.changeCurrentVideoTakes();
        }
        else {
          this.loadVideoTakeFolders();
        }
        // Set up videorecordings.js variables
        if(this.isController){
          setGetLastVideoTake(this.getLastVideoTake)
          setVideoTakeFolderId(this.currentVideoTakeFolderId)
        }
        // // Fetch Rolls info
        this.updateRollsState(this.resetFilter)
        this.setHostEvents();

        // setup video leadership and set the leader as the default (as host is always the leader in the begining)
        setupVideoLeadershipMessageTypes(true, null, this.setVideoLeaderCallback)
        break;
      }

      return;
      hooksManager.registerNewHook('video-take-list--autoplay-when-ready', 'video-leadership--user-ready', (data) => {
        let play = true;
        this.participants.forEach( (participant) => {
          let status = $(`#ready_${participant.role}_${participant.id} .status`).html();
          if (status == "LOADING ⏳") play = false;
        })
        if (play) {
          if(this.processingClip){
            this.playWhenReady = true;
          } else{
            // generally when latency is low it takes longer to setup the clips because the host has to play thru all the clip
          window.setTimeout( () => {
            window.playbackPlayer.play();
          }, 1000)
        }
      }
    })
    }
  },

  mounted() {
    window.setTimeout(()=>{
      this.initialize()
    }, 5000)
  },
  watch: {
    currentVideoTakeFolderId: function (newValue, oldValue){
      if(this.isController)
        setVideoTakeFolderId(newValue)
    }
  },
  computed: {
    videoId(){
      return 'videoTakePlayback' + (this.isController ? '_controller' : '_review') + "_" + this.uniqueId;
    },
    groupedVideoTakes(){
      let rolls = {}
      this.filteredVideoTakes.forEach( vt => {
        if (rolls[vt.roll_id] == undefined){
          rolls[vt.roll_id] = [];
        }
        rolls[vt.roll_id].push(vt);
      })
      return rolls;
    },
    // utility function to show the takes in the reversed order
    reversedCurrentVideoTakes(){
      if (this.currentVideoTakes == undefined) return [];
      return this.currentVideoTakes.reverse()
    },
    // utility function to show the takes in the reversed order
    filteredVideoTakes(){
      const takes = this.reversedCurrentVideoTakes
      if (this.showFavorites) return takes.filter((vt) => { return vt.is_favorite === true })
      else return takes;
    },
    hostSelectedFolderName(){
      if(this.hostFolderSelected == 'none') return 'None';
      const folder = this.videoTakesFolders.find( (f) => { return f.id == this.hostFolderSelected })
      if (folder == undefined) return 'None';
      return folder.name;
    },
  }
}
</script>

<style lang="scss" scoped>
.-rotate-270{
    transform: rotate(-270deg)!important;
}

#readyToPlay {
    /* width: 640px; */
    /* height: 365px; */
    position: relative;
}

.video-overlay{
    opacity: 0
}
.video-overlay{
    opacity: 1;
    background: linear-gradient(1deg, #0000006b 10%, transparent, transparent, #00000069 90%);
    transition: opacity 0.1s ease-in-out;
}

.video-controls {
  display: flex;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1rem;
}

.video-controls:hover .slider {
    opacity: 1;
}

/* The slider itself */
.slider {
  -webkit-appearance: none;  /* Override default CSS styles */
  appearance: none;
  width: 100%;
  height: 8px;
  background: #262b73;
  border: 1px solid #001476;
  outline: none;
  border-radius: 5px;
  opacity: 0.8;
    transition: linear 0.1s all;
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.slider::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  width: 15px; /* Set a specific slider handle width */
  height: 15px; /* Slider handle height */
  background: white; /* Green background */
  cursor: pointer; /* Cursor on hover */
  border-radius: 10px;
  box-shadow: 0px 0px 2px rgba(0,0,0,0.2);
  border: 1px solid gray;
}
</style>
